import React from "react";

import { body } from "./placeholder.module.scss";

const PlaceholderBody = (props) => (
  <span className={body} {...props}/>
);

export default PlaceholderBody;
